// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IModelResponse, IModel } from '@cian/http-api';
import type { ICheckPaymentResponse } from '../../entities/Models/CheckPaymentResponse';

export interface ICheckPaymentByProviderRequest {
  /** Провайдер платежей **/
  paymentProvider: EPaymentProvider;
  /** Внешний id платежа провайдера **/
  externalPaymentId: string;
}
export enum EPaymentProvider {
  /** Провайдер неопределен **/
  'Unknown' = 'unknown',
  /** ЮKassа (https://yookassa.ru/developers) **/
  'YooKassa' = 'yooKassa',
  /** CloudPayments (https://developers.cloudpayments.ru/#svodka-izmeneniy) **/
  'CloudPayments' = 'cloudPayments',
}

export type ICheckPaymentByProviderResponse = ICheckPaymentResponse;

export interface ICheckPaymentByProviderResponse200 extends IModelResponse<ICheckPaymentByProviderResponse> {
  statusCode: 200;
}

export type TCheckPaymentByProviderResponse = ICheckPaymentByProviderResponse200;

export type TCheckPaymentByProviderModel = IModel<ICheckPaymentByProviderRequest, TCheckPaymentByProviderResponse>;

export interface IMappers<TResponse200> {
  200(response: ICheckPaymentByProviderResponse): TResponse200;
}
